import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import ContactUsHomeContent from './contact-home-contents.md';
import { ContactPixelRetargeting } from '../../../components/retargetting';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const WrapperComponent = makeShortcode("WrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading" variant="fullwidth" theme="dark" customLayout className="contactUsHerobgImage Hero-Banner Contact-Home" mdxType="Hero" />
    <h1 {...{
      "id": "were-here-to-help"
    }}>{`We're here to help.`}</h1>
    <WrapperComponent slots="content" theme="lightest" className="contactUs-div-flex overflow-hidden Contact-Home-Wrapper" mdxType="WrapperComponent" />
    <ContactUsHomeContent mdxType="ContactUsHomeContent" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      